export enum Permission {
    CAN_CREATE_TENANTS = 'CAN_CREATE_TENANTS',
    CAN_CREATE_TPO_PROJECT_TYPES = 'CAN_CREATE_TPO_PROJECT_TYPES',
    CAN_CREATE_TPO_PROJECTS = 'CAN_CREATE_TPO_PROJECTS',
    CAN_PERFORM_QA = 'CAN_PERFORM_QA',
    CAN_REMOVE_QA_LOCK = 'CAN_REMOVE_QA_LOCK',
    CAN_SWITCH_TENANTS = 'CAN_SWITCH_TENANTS',
    CAN_VIEW_AUDIT_LOGS = 'CAN_VIEW_AUDIT_LOGS',
    CAN_VIEW_CHART_WORKBENCH = 'CAN_VIEW_CHART_WORKBENCH',
    CAN_VIEW_CREATE_PREMATCHES = 'CAN_VIEW_CREATE_PREMATCHES',
    CAN_VIEW_DATAVANTER_MENU = 'CAN_VIEW_DATAVANTER_MENU',
    CAN_VIEW_ONSHORE_CHARTS = 'CAN_VIEW_ONSHORE_CHARTS',
    CAN_VIEW_QA_ALL_TAB = 'CAN_VIEW_QA_ALL_TAB',
    CAN_VIEW_QA_LOCKED_CHARTS = 'CAN_VIEW_QA_LOCKED_CHARTS',
    CAN_VIEW_QA_WORKBENCH = 'CAN_VIEW_QA_WORKBENCH',
    CAN_VIEW_TPO_PROJECT_TYPES = 'CAN_VIEW_TPO_PROJECT_TYPES',
    CAN_VIEW_TPO_PROJECTS = 'CAN_VIEW_TPO_PROJECTS',
    CAN_CREATE_CDE = 'CAN_CREATE_CDE',
    CAN_UPDATE_CUSTOMER_SETTINGS = 'CAN_UPDATE_CUSTOMER_SETTINGS',
    CAN_VIEW_UPLOAD_UNIVERSAL_ROSTER = 'CAN_VIEW_UPLOAD_UNIVERSAL_ROSTER',
    CAN_VIEW_ORGANIZATION_INFORMATION = 'CAN_VIEW_ORGANIZATION_INFORMATION',
    CAN_VIEW_USER_MANAGEMENT = 'CAN_VIEW_USER_MANAGEMENT',
    CAN_PERFORM_RETRIEVAL_TASKS = 'CAN_PERFORM_RETRIEVAL_TASKS',
    CAN_VIEW_LOCKED_RETRIEVAL_TASKS = 'CAN_VIEW_LOCKED_RETRIEVAL_TASKS',
    CAN_VIEW_ONSHORE_RETRIEVAL_TASKS = 'CAN_VIEW_ONSHORE_RETRIEVAL_TASKS',
    CAN_DOWNLOAD_RETRIEVAL_INVENTORY_REPORT = 'CAN_DOWNLOAD_RETRIEVAL_INVENTORY_REPORT',
    CAN_REMOVE_RETRIEVAL_TASK_LOCK = 'CAN_REMOVE_RETRIEVAL_TASK_LOCK',
    CAN_VIEW_REQUEST_MANAGER = 'CAN_VIEW_REQUEST_MANAGER',
    CAN_VIEW_EMBEDDED_ADDRESS_DRA_FEEDBACK = 'CAN_VIEW_EMBEDDED_ADDRESS_DRA_FEEDBACK',
    CAN_EDIT_EMBEDDED_ADDRESS_DRA_FEEDBACK = 'CAN_EDIT_EMBEDDED_ADDRESS_DRA_FEEDBACK',
    CAN_VIEW_DF_ROI_EMBEDDED_ROSTER = 'CAN_VIEW_DF_ROI_EMBEDDED_ROSTER',
    CAN_VIEW_PROJECTS = 'CAN_VIEW_PROJECTS',
    CAN_CREATE_PROJECTS = 'CAN_CREATE_PROJECTS',
    CAN_EDIT_PROJECTS = 'CAN_EDIT_PROJECTS',
    CAN_VIEW_ORDER_TEMPLATES = 'CAN_VIEW_ORDER_TEMPLATES',
    CAN_CREATE_ORDER_TEMPLATES = 'CAN_CREATE_ORDER_TEMPLATES',
    CAN_EDIT_ORDER_TEMPLATES = 'CAN_EDIT_ORDER_TEMPLATES',
    CAN_VIEW_ORDERS = 'CAN_VIEW_ORDERS',
    CAN_CREATE_ORDERS = 'CAN_CREATE_ORDERS',
    CAN_EDIT_ORDERS = 'CAN_EDIT_ORDERS',
    CAN_DISPATCH_ORDERS = 'CAN_DISPATCH_ORDERS',
    CAN_VIEW_ACTION_CENTER = 'CAN_VIEW_ACTION_CENTER',
    CAN_MANAGE_EMBEDDED_RECORD_REQUESTS = 'CAN_MANAGE_EMBEDDED_RECORD_REQUESTS',
    CAN_UPDATE_PROVIDER_CONTACT_INFO = 'CAN_UPDATE_PROVIDER_CONTACT_INFO',
    CAN_VIEW_INVOICE_CONFIGURATION = 'CAN_VIEW_INVOICE_CONFIGURATION',
    CAN_CREATE_INVOICE_CONFIGURATION = 'CAN_CREATE_INVOICE_CONFIGURATION',
    CAN_EDIT_INVOICE_CONFIGURATION = 'CAN_EDIT_INVOICE_CONFIGURATION',
    CAN_VIEW_INVOICE_REPORT = 'CAN_VIEW_INVOICE_REPORT',
    CAN_VIEW_DLQ_TRIAGE = 'CAN_VIEW_DLQ_TRIAGE',
    CAN_VIEW_PPT_FEE_SCHEDULES = 'CAN_VIEW_PPT_FEE_SCHEDULES',
    CAN_CREATE_PPT_FEE_SCHEDULES = 'CAN_CREATE_PPT_FEE_SCHEDULES',
    CAN_EDIT_PPT_FEE_SCHEDULES = 'CAN_EDIT_PPT_FEE_SCHEDULES',
    CAN_CANCEL_IN_PROGRESS_ORDERS = 'CAN_CANCEL_IN_PROGRESS_ORDERS',
}
